import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../login/AuthProvider";
import SwitchBox from "../../components/switchBox";
import {switchHelper, dateHelper, dictFinder} from "../../modules/helpers";
import PageList from "../../components/pageList";
import { news, news_page, art_type, backend } from '../../components/apipath';
import HTMLEditor from "../../components/htmleditor";
//import CKEditorClassic from "../../components/ckeditor";
let htmlIntroContent = '';
let htmlMainContent = '';
let htmlIntroContent2 = '';
let htmlMainContent2 = '';

function AdmNews() {
    const [newsData, setNewsData] = useState();
    const [artTypeList, setArtTypeList] = useState();
    const [displayOrder, setDisplayOrder] = useState();
    const [rowsCount, setRowsCount] = useState();
    const [editingNews, setEditingNews] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [newData, setNewData] = useState();
    const navigate = useNavigate();
    const { token, type } = useAuth();
    const [isSubmitting, setIsSubmitting] = useState(false)

    

    const fetchNewsData = async (page=1, rows=50) => {
        try {
            if(page-1 <= 0) page=1;
            const response = await axios.get(`${news_page(page-1, rows)}`, {headers:{token: token}});
            setNewsData(response.data[0].data);
            setRowsCount(response.data[1].data[0].total);
            setDisplayOrder(response.data[2].data)
            console.log('News API URL:', news_page(page-1, rows));
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const fetchArtTypeList = async () => {
        try {
            const response = await axios.get(`${art_type}`, {headers:{token: token}});
            console.log('News API Response:', response.data);
            setArtTypeList(response.data.data);
            console.log('Updated ArtTypeList:', response.data.data);
        } catch (error) {
            console.error('Error:', error);
        }
    }

    useEffect(()=>{
        fetchNewsData();
    }, []);

    useEffect(()=>{
        fetchArtTypeList();
    }, []);
    
    const startEditing = (newsItem) => {
        htmlIntroContent2 = newsItem.intro;
        htmlMainContent2 = newsItem.content;
        setEditingNews(newsItem);
        setUpdatedData(newsItem);
    };

    
    const handleAddNew = () => {
        setNewData({
            cate_id: 0,
            art_type: 0,
            art_type_name: '',
            is_top: 0,
            status: 1,
            title: null,
            intro: null,
            content: null,
            cover_1: null,
            art_date: null,
            disp_order: null,
            link: null,
        });
    };

    const handleNewIntroChange = (name, contents) => {
        htmlIntroContent = contents;
    }
    const handleNewContentChange = (name, contents) => {
        htmlMainContent = contents;
    }

    const handleUpdateIntroChange = (name, contents) => {
        htmlIntroContent2 = contents;
    }
    const handleUpdateContentChange = (name, contents) => {
        htmlMainContent2 = contents;
    }
    // Create 處理新行輸入的變化
    const handleNewInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['checkbox'].includes(type)){
            setNewData({
                ...newData,
                [name]: switchHelper(checked),
            });
        } else if (name === 'art_type') {
            let tmpOrder = 0
            for(let i in displayOrder){
                if(parseInt(displayOrder[i].art_type) === parseInt(value)){
                    tmpOrder = parseInt(displayOrder[i].disp_order) + 1;
                    break;
                }
            }
            setNewData({
                ...newData,
                [name]: value,
                disp_order: tmpOrder,
                art_type_name: dictFinder(artTypeList, 'art_type', value).name
            });
        } else if (name === 'cover_1') {
            if (e.target.files){
                setNewData({
                    ...newData,
                    [name]: value,
                    cover_file: e.target.files[0],
                });
            } else {
                setNewData({
                    ...newData,
                    [name]: value,
                });
            }
        } else {
            setNewData({
                ...newData,
                [name]: value,
            });
        }
    };

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['checkbox'].includes(type)){
            setUpdatedData({
                new_id: editingNews.new_id,
                ...updatedData,
                [name]: switchHelper(checked),
            });
        } else if (name === 'cover_1') {
            if (e.target.files){
                setUpdatedData({
                    ...updatedData,
                    [name]: value,
                    cover_file: e.target.files[0],
                });
            } else {
                setUpdatedData({
                    ...updatedData,
                    [name]: value,
                });
            }
        } else {
            setUpdatedData({
                new_id: editingNews.new_id,
                ...updatedData,
                [name]: value,
            });
        }
    };

    const handleNext = async (obj) => {
        try{
            const order = parseInt(obj.disp_order);
            let objData = {
                ...obj,
                disp_order: (order + 1),
                cover_1: null,
                cover_file: null
            }
            const res = await axios.put(`${news}`, objData, {headers: {
                Authorization: `Bearer ${token}`,
                token: token,
              }});
            if (res.data.status !== 200)
                console.error(res.data.msg);
            else{
                const updatedNewsList = newsData.map(news => {
                    if (news.new_id === obj.new_id) {
                        return {
                            ...obj,
                            disp_order: (order + 1),
                        };
                    }
                    return news;
                });
                setNewsData(updatedNewsList);
            }
        } catch(err){
            console.error(err)
        }
    }

    const handlePrevious = async (obj) => {
        try{
            const order = parseInt(obj.disp_order);
            let objData = {
                ...obj,
                disp_order: ((order - 1) >= 0 ? (order - 1) : 0),
                cover_1: null,
                cover_file: null
            }
            const res = await axios.put(`${news}`, objData, {headers: {
                Authorization: `Bearer ${token}`,
                token: token,
              }});
            if (res.data.status !== 200)
                console.error(res.data.msg);
            else{
                const updatedNewsList = newsData.map(news => {
                    if (news.new_id === obj.new_id) {
                        return {
                            ...obj,
                            disp_order: (order - 1),
                        };
                    }
                    return news;
                });
                setNewsData(updatedNewsList);
            }
        } catch(err){
            console.error(err)
        }
    }

    const handleDeleted = async (id) => {
        if(window.confirm("確認刪除 ?")){
            try{
                const res = await axios.delete(`${news}${id}`, {data: { new_id: id },headers: {
                    Authorization: `Bearer ${token}`,
                    token: token,
                  }});
                if (res.data.status !== 200)
                    console.error(res.data.msg);
                else
                    fetchNewsData();
            } catch(err){
                console.error(err)
            }
            
        }
    }

    const handleSaveNew = async () => {
        setIsSubmitting(true);
        try {
            let uploadedCoverPath = null;
    
            // 先上傳圖片
            if (newData.cover_file) {
                const formData = new FormData();
                formData.append("file", newData.cover_file);
    
                const uploadRes = await axios.post(`${news}upload`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        token: token,
                    },
                });
    
                if (uploadRes.status === 200 && uploadRes.data.filePath) {
                    uploadedCoverPath = uploadRes.data.filePath;
                } else {
                    throw new Error("圖片上傳失敗");
                }
            }
    
            // 組裝要送出的資料（注意 cover_1 是圖片網址，不是 file）
            const newDatas = {
                ...newData,
                intro: htmlIntroContent,
                content: htmlMainContent,
                cover_1: uploadedCoverPath,
            };
    
            const response = await axios.post(`${news}`, newDatas, {
                headers: {
                    token,
                },
            });
    
            if (response.data.status !== 200) {
                throw new Error(response.data.msg);
            }
    
            fetchNewsData();
            htmlIntroContent = '';
            htmlMainContent = '';
            setEditingNews(null);
            setNewData(null);
        } catch (error) {
            console.error("新增失敗:", error);
        }
        setIsSubmitting(false);
    };

    //Update 將資訊依照new_id回傳給後端
    const saveChanges = async () => {
        try {
            let uploadedCoverPath = updatedData.cover_1; // 預設使用原本圖片 URL
    
            // ✅ 如果有選新的檔案，就上傳
            if (updatedData.cover_file) {
                console.log("開始上傳圖片...", updatedData.cover_file);
    
                const formData = new FormData();
                formData.append("file", updatedData.cover_file);
    
                const uploadRes = await axios.post(`${news}upload`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        token,
                    },
                });
    
                console.log("圖片上傳回應:", uploadRes);
    
                if (uploadRes.status === 200 && uploadRes.data.filePath) {
                    uploadedCoverPath = uploadRes.data.filePath;
                } else {
                    console.error("圖片上傳錯誤:", uploadRes);
                    throw new Error("圖片上傳失敗");
                }
            }
    
            // ✅ 組裝要送出的資料（不再包含 File）
            const updateDatas = {
                ...updatedData,
                intro: htmlIntroContent2,
                content: htmlMainContent2,
                cover_1: uploadedCoverPath, // 存的是 URL，不是 File
            };
    
            // ✅ 發送 PUT 請求更新資料
            const response = await axios.put(`${news}`, updateDatas, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    token: token,
                },
            });
    
            if (response.data.status !== 200) {
                throw new Error(response.data.msg || "更新失敗");
            }
    
            // ✅ 更新前端狀態
            const updatedNewsList = newsData.map((news) =>
                news.new_id === editingNews.new_id ? updateDatas : news
            );
            setNewsData(updatedNewsList);
    
            // ✅ 清空編輯狀態
            htmlIntroContent2 = '';
            htmlMainContent2 = '';
            setEditingNews(null);
    
            console.log("更新成功");
        } catch (error) {
            console.error("更新失敗:", error);
            alert(error.message || "更新失敗，請稍後再試");
        }
    };
    return (
        <>
        <div className="mt100 w-75 mx-auto">
            <div className="text-end mt-2">
                <button className="btn btn-success btn-sm me-2" onClick={handleAddNew}>新增</button>
            </div>
            <div className="mt-2 table-responsive">
                <table className="table table-striped border table-hover">
                    <thead>
                        <tr>
                            <th scope="col">主標</th>
                            <th scope="col">副標</th>
                            <th scope="col">內容</th>
                            <th scope="col">圖片</th>
                            <th scope="col">日期</th>
                            <th scope="col">功能</th>
                        </tr>
                    </thead>
                    <tbody>
                        {newData && (
                            <tr>
                                <td colSpan={4}>
                                    <div className="row g-2">
                                        <div className="col-xl-3 col-md-4 col-6">
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text">分類</span>
                                                <select
                                                    className="form-select form-select-sm"
                                                    name="art_type"
                                                    onChange={handleNewInputChange}
                                                    required
                                                >
                                                    <option key={0} value={''}>請選擇</option>
                                                    {artTypeList.map((item, index)=>(
                                                        <option key={item.type_id} value={item.type_id}>{item.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-md-4 col-6">
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text">主標</span>
                                                <input 
                                                    className="form-control form-control-sm"
                                                    onChange={handleNewInputChange}
                                                    type="text"
                                                    name="title"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-xl-2 col-md-3 col-4">
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text">文章日期</span>
                                                <input 
                                                    className="form-control form-control-sm"
                                                    onChange={handleNewInputChange}
                                                    type="date"
                                                    name="art_date"
                                                    defaultValue={dateHelper(Date.now(), 'date')}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        
                                        <div className="col-xl-2 col-md-3 col-4">
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text">排序</span>
                                                <input 
                                                    className="form-control form-control-sm"
                                                    onChange={handleNewInputChange}
                                                    type="number"
                                                    step={1}
                                                    name="disp_order"
                                                    defaultValue={newData.disp_order}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-md-4 col-6">
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text">封面</span>
                                                <input 
                                                    className="form-control form-control-sm"
                                                    onChange={handleNewInputChange}
                                                    type="file"
                                                    name="cover_1"
                                                    accept="image/png, image/jpeg, image/jpg, , image/bmp, image/gif"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-md-4 col-6">
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text">連結</span>
                                                <input 
                                                    className="form-control form-control-sm"
                                                    onChange={handleNewInputChange}
                                                    type="text"
                                                    name="link"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-xl-1 col-md-2 col-3">
                                            {SwitchBox('is_top', 0, handleNewInputChange, '頂置')}
                                        </div>
                                        <div className="col-xl-1 col-md-2 col-3">
                                            {SwitchBox('status', 1, handleNewInputChange, '啟用')}
                                        </div>
                                        <div className="col-12">
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text">副標</span>
                                                {HTMLEditor('', 'intro', handleNewIntroChange)}
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text">內容</span>
                                                {HTMLEditor('', 'content', handleNewContentChange)}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <button
                                        className="btn btn-primary m-1"
                                        onClick={handleSaveNew}
                                    >
                                        保存
                                    </button>
                                    <button
                                        className="btn btn-secondary m-1"
                                        onClick={() => {
                                            setNewData(null);
                                            htmlIntroContent = '';
                                            htmlMainContent = '';
                                        }}
                                    >
                                        取消
                                    </button>
                                </td>
                            </tr>
                        )}
                        { newsData && newsData.map((news) => (
                            <tr key={news.new_id}>
                                {editingNews && editingNews.new_id === news.new_id ? (
                                <>
                                    <td colSpan={4}>
                                        <div className="row g-2">
                                            <div className="col-xl-3 col-md-4 col-6">
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text">分類</span>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="art_type"
                                                        onChange={handleInputChange}
                                                        defaultValue={news.art_type}
                                                        required
                                                    >
                                                        <option key={0} value={''}>請選擇</option>
                                                        {artTypeList.map((item, index)=>(
                                                            <option key={item.type_id} value={item.type_id}>{item.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-xl-3 col-md-4 col-6">
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text">主標</span>
                                                    <input 
                                                        className="form-control form-control-sm"
                                                        onChange={handleInputChange}
                                                        defaultValue={news.title}
                                                        type="text"
                                                        name="title"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-2 col-md-3 col-4">
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text">文章日期</span>
                                                    <input 
                                                        className="form-control form-control-sm"
                                                        onChange={handleInputChange}
                                                        type="date"
                                                        name="art_date"
                                                        defaultValue={dateHelper(news.art_date ?? Date.now(), 'date')}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            
                                            <div className="col-xl-2 col-md-3 col-4">
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text">排序</span>
                                                    <input 
                                                        className="form-control form-control-sm"
                                                        onChange={handleInputChange}
                                                        type="number"
                                                        step={1}
                                                        name="disp_order"
                                                        defaultValue={news.disp_order}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-1 col-md-2 col-3">
                                                {SwitchBox('is_top', news.is_top, handleInputChange, '頂置')}
                                            </div>
                                            <div className="col-xl-1 col-md-2 col-3">
                                                {SwitchBox('status', news.status, handleInputChange, '啟用')}
                                            </div>
                                            <div className="col-xl-3 col-md-4 col-6">
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text">連結</span>
                                                    <input 
                                                        className="form-control form-control-sm"
                                                        onChange={handleInputChange}
                                                        type="text"
                                                        name="link"
                                                        defaultValue={news.link}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-6 col-md-8 col-12">
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text">封面</span>
                                                    <input 
                                                        className="form-control form-control-sm"
                                                        onChange={handleInputChange}
                                                        type="file"
                                                        name="cover_1"
                                                        accept="image/png, image/jpeg, image/jpg, , image/bmp, image/gif"
                                                    />
                                                    <small className="input-group-text text-muted">{news.cover_1 ? "再次選擇檔案" : "請選擇檔案"}</small>
                                                </div>
                                            </div>
                                            <div className="col-xl-3 col-md-4 col-6">
                                                <div className="input-group input-group-sm">
                                                    <img src={news.cover_1} alt="" className="card-img" />
                                                </div>
                                            </div>
                                            <div className="col-12 w-100">
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text">副標</span>
                                                    {HTMLEditor(news.intro, 'intro', handleUpdateIntroChange)}
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="input-group input-group-sm w-100">
                                                    <span className="input-group-text">內容</span>
                                                    {HTMLEditor(news.content, 'content', handleUpdateContentChange)}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <button
                                            className="btn btn-primary btn-sm m-1"
                                            onClick={saveChanges}
                                        >
                                            保存
                                        </button>
                                        <button
                                            className="btn btn-secondary btn-sm m-1"
                                            onClick={() => {
                                                setEditingNews(null);
                                                htmlIntroContent2 = '';
                                                htmlMainContent2 = '';
                                            }}
                                        >
                                            取消
                                        </button>
                                    </td>
                                </>) : 
                                (<>
                                    <td className="col-2">
                                        <div className="mb-2">
                                            {news.is_top ? (<i className="fa-solid fa-thumbtack fa-fw me-1 text-success"></i>) : ''} 
                                            {!news.status ? (<i className="fa-regular fa-eye-slash fa-fw me-1 text-danger"></i>) : <i className="fa-regular fa-eye me-1 text-warning"></i>} 
                                            <strong>{news.art_type_name}</strong>
                                        </div>
                                        {news.title}
                                    </td>
                                    <td className="col-2">
                                    <div className="table-responsive" style={{maxWidth: "400px", maxHeight: "300px"}}>
                                            <table className="table table-striped">
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <div dangerouslySetInnerHTML={{__html:news.intro}}></div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                    <td className="col-4">
                                        <div className="table-responsive" style={{maxWidth: "400px", maxHeight: "300px"}}>
                                            <table className="table table-striped">
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <div dangerouslySetInnerHTML={{__html:news.content}}></div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                    <td className="col-2">
                                        <div>
                                            <img src={`${backend}${news.cover_1}`} alt="" style={{width: "100%"}} />
                                        </div>
                                        
                                    </td>
                                    <td className="col-2">
                                        <span className="text-nowrap">{dateHelper(news.art_date, 'date')}</span>
                                    </td>
                                    <td className="col-2">
                                        <button className="btn btn-sm btn-success m-1" onClick={() => handlePrevious(news)}>上移</button>
                                        <button className="btn btn-sm btn-warning m-1" onClick={() => handleNext(news)}>下移</button>
                                        <button className="btn btn-sm btn-primary m-1" onClick={() => startEditing(news)}>編輯</button>
                                        { type === 'admin' ? (
                                            <button className="btn btn-sm btn-danger m-1" onClick={() => handleDeleted(news.new_id)}>刪除</button>
                                        ) : (<></>)}
                                    </td>
                                </>)}
                            </tr>
                        ))}
                        
                    </tbody>
                </table>
            </div>
        </div>
        <div className="m-2 p-2">
            { PageList(rowsCount, fetchNewsData) }
        </div>
        </>
    );
}
export default AdmNews;